import { DEFAULT_ANNUAL_INTEREST_RATE } from '#app/routes/_admin+/admin.cars+/ui/ProductPrice.tsx'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'
import {
  Breadcrumb,
  breadcrumbHome,
} from '#app/shared/ui/navigation/Breadcrumb.js'

type Props = {}

export default function Hero({}: Props) {
  return (
    <MainContainer>
      <div
        className={`
          relative mt-10 flex flex-col justify-left items-center px-2 pb-10

          lg:mr-0 lg:mt-[100px] lg:items-start lg:px-4 lg:pb-0

          xl:px-2
        `}
      >
        <div
          className={`
            absolute top-[-100px] hidden

            lg:block
          `}
        >
          <Breadcrumb
            items={[breadcrumbHome, { label: 'Financiación' }]}
            variant="light"
          />
        </div>

        <p
          className={`
            w-auto max-w-[328px] text-center max-w text-h3 text-white

            lg:mt-[50px] lg:w-[622px] lg:max-w-none lg:text-left lg:text-h2
            lg:leading-[52px]
          `}
        >
          Financiación al {DEFAULT_ANNUAL_INTEREST_RATE}% TIN, con coche de
          sustitución, seguro de vida, invalidez y retirada de carnet. Sin
          complicaciones y a tu medida.
        </p>
        <p
          className={`
            mt-6 w-[328px] text-center text-h5-medium text-white

            lg:w-[518px] lg:text-left
          `}
        >
          Contrata nuestro Pack Óptima y obtén un descuento de hasta 2.000€, dos
          años de garantía, una escapada a Formentera y más beneficios.
        </p>
      </div>
    </MainContainer>
  )
}
